import React, { useCallback } from 'react';

type RefObjectToMutableRefObject<T> = T extends React.RefObject<infer U> ? React.MutableRefObject<U> : never;

export const useAggregatedRef = <T extends unknown>(refs: React.Ref<T>[]): React.RefCallback<T> =>
  useCallback(
    (instance: T) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(instance);
        } else if (ref && 'current' in ref) {
          // eslint-disable-next-line no-param-reassign -- mutable refs are mutable by design
          (ref as RefObjectToMutableRefObject<typeof ref>).current = instance;
        }
      });
    },
    [refs],
  );
